export const API_SERVER_TIMEOUT = 180_000;
export const API_VERSION = "v1";
